module.exports = __webpack_public_path__ + "img/banner-recommend.4c3f2d2f.png";